import React, { useEffect, useState } from "react";
import axios from "axios";
import PackageCard from "./PackageCard";
import "./PackageList.css";
import GalleryDisplay from "./GalleryDisplay";
import CTASection from "../CTASection/CTASection";

// const BASE_URL = "https://atlastravelhouse.com/api";
const BASE_URL = "https://atlastravelhouse.com";


function PackageList() {
  const [domesticPackages, setDomesticPackages] = useState([]);
  const [internationalPackages, setInternationalPackages] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/packages/?category=domestic`)
      .then((res) => setDomesticPackages(res.data))
      .catch((err) => console.log(err));

    axios
      .get(`${BASE_URL}/api/packages/?category=international`)
      .then((res) => setInternationalPackages(res.data))
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <div className="package-container">
        <h1 className="pkgheading">Packages</h1>
        {/* <h1 className="pkgheading">Packages</h1> */}

        <h2 className="pkgsubheading1">Domestic</h2>
        <div className="package-list-wrapper">
          <div className="overlap-img">
            <img src={require("../../assets/plane.webp")} alt="Plane" />
          </div>
          <div className="package-list">
            {domesticPackages.length > 0 ? (
              domesticPackages.map((pkg) => (
                <PackageCard key={pkg.id} pkg={pkg} />
              ))
            ) : (
              <p className="no-data">No Domestic Packages Available</p>
            )}
          </div>
        </div>

        <h2 className="pkgsubheading2">International</h2>
        <div className="package-list-wrapper">
          <div className="overlap-img">
            <img src={require("../../assets/plane.webp")} alt="Plane" />
          </div>
          <div className="package-list">
            {internationalPackages.length > 0 ? (
              internationalPackages.map((pkg) => (
                <PackageCard key={pkg.id} pkg={pkg} />
              ))
            ) : (
              <p className="no-data">No International Packages Available</p>
            )}
          </div>
        </div>
        
        <CTASection />
        <GalleryDisplay />
      </div>
    </>
  );
}

export default PackageList;
